import * as React from "react";
import { StatusIcon } from "components/common";
import Spinner from "components/common/Spinner";
const PENDING_STATUSSES = ["STARTING", "RUNNING", "RETRYING"];
const HasAsset = ({ value, status }) => !value && PENDING_STATUSSES.includes(status) ? /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: "" }) : /* @__PURE__ */ React.createElement(StatusIcon, { active: value });
export default HasAsset;
